var path = 'app/scripts/modules/ecs/serverGroup/configure/wizard/horizontalScaling/horizontalScaling.html';
var html = "<div class=\"clearfix\">\n  <div class=\"row\">\n    <div class=\"col-md-12\">\n      <ecs-server-group-horizontal-scaling command=\"command\" application=\"application\"></ecs-server-group-horizontal-scaling>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/ecs/serverGroup/configure/wizard/horizontalScaling/horizontalScaling.html
// module id = 1617
// module chunks = 0